/** @jsxRuntime classic */
/** @jsx jsx */
import { jsx } from "@emotion/react";

import type { FC, SVGAttributes } from "react";

type Props = SVGAttributes<SVGElement>;

export const PlusIcon: FC<Props> = (props) => (
  <svg viewBox="0 0 16 16" fill="none" {...props}>
    <path
      d="M7.75 1V14.5M14.5 7.75H1"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeOpacity="0.92"
      strokeWidth="2"
    />
  </svg>
);
